import { generateColorPalette } from "@commerce-ui/core2/generateColorPalette";

const theme = () => {
  const space = [];
  space.s0 = 0;
  space.s1 = 1;
  space.s2 = 2;
  space.s3 = 4;
  space.s4 = 6;
  space.s5 = 8;
  space.s6 = 12;
  space.s7 = 16;
  space.s8 = 24;
  space.s9 = 32;
  space.s10 = 48;
  space.s11 = 64;
  space.s12 = 96;
  space.s13 = 128;
  space.s14 = 160;

  space.containerMargin = [
    "5vw",
    null,
    null,
    null,
    "7.5vw",
    "calc(50vw - 706px)"
  ];
  space.gridGap = [10, null, null, 15, 25, 32];

  space.notificationSystemOffset = 16;
  space.notificationSystemSeparator = 16;
  space.notificationSystemWidth = 300;

  const breakpoints = ["420px", "720px", "960px", "1200px", "1600px"];
  breakpoints.xs = breakpoints[0];
  breakpoints.sm = breakpoints[1];
  breakpoints.md = breakpoints[2];
  breakpoints.lg = breakpoints[3];
  breakpoints.xl = breakpoints[4];

  const FONT_NANTES = "'NantesWeb', serif";
  const FONT_FRANKLIN_MEDIUM = "'FranklinGothicURW-Med', sans-serif";
  const FONT_FRANKLIN_BOOK = "'FranklinGothicURW-Boo', sans-serif";
  const FONT_NORTHWELL = "'Northwell', sans-serif";

  const fonts = {
    xxl: {
      //heading1
      fontSize: 32,
      fontFamily: FONT_NANTES,
      lineHeight: 1,
      fontWeight: 400
    },
    xxl_handwritten: {
      fontSize: 60,
      fontFamily: FONT_NORTHWELL,
      lineHeight: 1.5,
      fontWeight: 400
    },
    xxl_sans: {
      fontSize: 40,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1,
      fontWeight: 500
    },
    xxl_sans_bigger: {
      fontSize: 72,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1,
      fontWeight: 500
    },
    xl: {
      fontSize: 32,
      fontFamily: FONT_NANTES,
      lineHeight: 1.14,
      fontWeight: 500
    },
    xl_handwritten: {
      fontSize: 48,
      fontFamily: FONT_NORTHWELL,
      lineHeight: 1.6,
      fontWeight: 400
    },
    xl_sans: {
      fontSize: 28,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1.1,
      fontWeight: 500
    },
    l: {
      fontSize: 20,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1.2,
      fontWeight: 500
    },
    base: {
      fontSize: 18,
      fontFamily: FONT_NANTES,
      lineHeight: 1.5,
      fontWeight: 400
    },
    base_sans: {
      fontSize: 17,
      fontFamily: FONT_FRANKLIN_BOOK,
      lineHeight: 1.3,
      fontWeight: 400
    },
    base_italic: {
      fontSize: 17,
      fontFamily: FONT_NANTES,
      lineHeight: 1.5,
      fontWeight: 400
    },
    s: {
      fontSize: 15,
      fontFamily: FONT_NANTES,
      lineHeight: 1.4,
      fontWeight: 400
    },
    s_sans: {
      fontSize: 16,
      fontFamily: FONT_FRANKLIN_BOOK,
      lineHeight: 1.4,
      fontWeight: 400
    },
    s_italic: {
      fontSize: 15,
      fontStyle: "italic",
      fontFamily: FONT_NANTES,
      lineHeight: 1.4,
      fontWeight: 400
    },
    s_caps: {
      fontSize: 15,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1.3,
      fontWeight: 500,
      textTransform: "uppercase",
      letterSpacing: "0.1em"
    },
    xs_caps: {
      fontSize: 14,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1.14,
      fontWeight: 500,
      textTransform: "uppercase"
    },
    xxs_caps: {
      fontSize: 12,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1.1,
      fontWeight: 500,
      textTransform: "uppercase"
    },
    xxs_caps_ext: {
      fontSize: 12,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1.1,
      fontWeight: 500,
      textTransform: "uppercase",
      letterSpacing: "0.1em"
    },
    base_sans_bold: {
      fontSize: 17,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1.4,
      fontWeight: 500
    },
    // TODO: zmienic na np. strikethrough
    base_sans_regular_discount: {
      fontSize: 16,
      fontFamily: FONT_FRANKLIN_BOOK,
      lineHeight: 1.5,
      fontWeight: 500,
      textDecoration: "line-through"
    },
    xs: {
      fontSize: 13,
      fontFamily: FONT_FRANKLIN_BOOK,
      lineHeight: 1.2,
      fontWeight: 400
    },
    xs_underline: {
      fontSize: 13,
      fontFamily: FONT_FRANKLIN_BOOK,
      lineHeight: 1.2,
      fontWeight: 400,
      textDecoration: "underline"
    },
    s_sans_bold: {
      fontSize: 15,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 1.4,
      fontWeight: 500
    },
    s_sans_underline: {
      fontSize: 15,
      fontFamily: FONT_FRANKLIN_BOOK,
      lineHeight: 1.4,
      fontWeight: 400,
      textDecoration: "underline"
    },
    l_normal: {
      fontSize: 20,
      fontFamily: FONT_FRANKLIN_BOOK,
      lineHeight: 1.2,
      fontWeight: 400
    },
    xxl_sans_desktop: {
      fontSize: 84,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      fontWeight: 500,
      letterSpacing: "-0.015em"
    },
    heading_large: {
      fontSize: 35,
      lineHeight: 1.3,
      fontWeight: 500,
      fontFamily: FONT_FRANKLIN_MEDIUM
    },
    sans_serif_22: {
      fontSize: 22,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 0.8
    },
    sans_serif_40: {
      fontSize: 40,
      fontFamily: FONT_FRANKLIN_MEDIUM,
      lineHeight: 0.6
    }
  };

  const {
    positive,
    positive100,
    positive300,
    positive500,
    positive700
  } = generateColorPalette("positive", "#6CAD85");
  const {
    negative,
    negative100,
    negative300,
    negative500,
    negative700
  } = generateColorPalette("negative", "#DF4F5C");
  const {
    neutral,
    neutral100,
    neutral300,
    neutral500,
    neutral700,
    neutral900
  } = generateColorPalette("neutral", "#EEECE5");

  return {
    colors: {
      main: "#2E4557",
      active: "#B05781",
      positive,
      positive100,
      positive500,
      positive700,
      negative,
      negative100,
      neutral300,
      negative500,
      negative700,
      neutral,
      neutral100,
      neutral500,
      neutral700,
      neutral900,
      blue: "#587A94",
      blueDark: "#1E47B0",
      blueDarken: "#192630",
      orange: "#ff824c",
      lightOrange: "#F9EBD9",
      darkOrange: "#DF773C",
      beigeLight: "#fdfdfc",
      beige: "#f4f3ee",
      beigeDarken: "#908F8A",
      darkViolet: "#904769",
      lightViolet: "#f9f2f5",
      greyLight: "#B7B8B1",
      grey: "#b8b7b1",
      christmasLightRed: "#af504a",
      christmasDarkRed: "#8A3733",
      christmasRed: "#a63b35",
      producerGrey: "#737F89",
      producerGreyLight: "#B8B7B1"
      /*      ...generateMonoPalette(),*/ // na razie nie potrzebna
    },
    typography: {
      ...fonts,
      body: fonts.base,
      body2: fonts.s_sans,
      heading1: fonts.xxl,
      heading2: fonts.xl,
      heading3: fonts.l,
      label: fonts.s_caps,
      label2: fonts.xs_caps
    },
    space,
    breakpoints,
    hideFocus: true
  };
};

export default theme;
